<template>
  <div class="box">
    <div class="box-head">
      <p>{{ boxheader }}</p>
      <p>
        <img
          @click="onAddItemClick"
          src="static/icons/add-icon.svg"
          class="dt-icon v4"
          alt="Add Group"
          title="Add Group"
        />
      </p>
    </div>
    <NTable
      class="items-list"
      :headers="headerArray"
      :items="items"
      :config="tableConfig"
    >
      <template v-slot:item="{ item }">
        <tr>
          <template v-if="!headerExists">
            <td
              v-if="labelKey"
              :class="`${labelKey} label_td`"
              @click="(e) => onSelectItem(item)"
            >
              <span>{{ item[labelKey] }}</span>
            </td>
            <td
              :class="`${fieldKey} dtable-field ${
                labelKey ? '' : 'first'
              }`"
            >
              <input
                v-if="fieldEditable"
                type="text"
                class="ntable--textfield"
                :name="`${fieldKey}-${item[primaryKey]}`"
                :id="`${fieldKey}-${item[primaryKey]}`"
                :placeholder="fieldPlaceholder"
                :value="item[fieldKey]"
                v-on:blur="
                  (e) => onTextInputBlur(e, fieldKey, item)
                "
              />
              <template v-else
                ><span>{{ item[fieldKey] }}</span></template
              >
            </td>
          </template>
          <template v-else>
            <td
              v-for="header of headers"
              :key="header.value"
              :class="`${header.selectable ? 'label_td' : ''}`"
              @click="
                (e) =>
                  header.selectable ? onSelectItem(item) : null
              "
            >
              <template
                v-if="header.type === DHeaderTypes.Text"
              >
                <span>{{ item[header.value] }}</span>
              </template>
              <template
                v-if="header.type === DHeaderTypes.TextField"
              >
                <input
                  type="text"
                  class="ntable--textfield"
                  :name="`${header.value}-${item[primaryKey]}`"
                  :id="`${header.value}-${item[primaryKey]}`"
                  :placeholder="header.placeholder"
                  :value="item[header.value]"
                  v-on:blur="
                    (e) =>
                      onTextInputBlur(e, header.value, item)
                  "
                />
              </template>
              <template
                v-if="header.type === DHeaderTypes.Checkbox"
              >
                <div class="checkbox-container">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="`${header.value}-${item[primaryKey]}`"
                      :id="`${header.value}-${item[primaryKey]}`"
                      :checked="item[header.value] == '1'"
                      @click="
                        (e) => onCheckboxChange(e, header, item)
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
              </template>
            </td>
          </template>
          <td class="option">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeleteItem(item)"
                :alt="`Delete ${itemName}`"
                :title="`Delete ${itemName}`"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../plugins/datatable";
import { DHeaderTypes, dHeader } from "./index";

export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    boxheader: {
      type: String,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    showHeader: {
      type: Boolean,
      default: false,
    },
    headerStyle: {
      type: Number,
      default: 2,
    },
    itemName: {
      required: true,
      type: String,
    },
    primaryKey: {
      required: true,
      type: String,
    },
    labelKey: {
      type: String,
    },
    fieldKey: {
      type: String,
    },
    fieldPlaceholder: {
      type: String,
    },
    fieldEditable: {
      default: true,
    },
  },
  data: function () {
    return {
      DHeaderTypes: DHeaderTypes,
    };
  },
  computed: {
    headerExists: function () {
      return this.headers && this.headers.length > 0
        ? true
        : false;
    },
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: this.headerStyle,
        rowHeight: 30,
        fullHeight: false,
        showHeader: this.showHeader,
      });
    },
    headerArray: function () {
      return [
        ...this.headers,
        dHeader({
          text: "",
          value: "options",
          type: DHeaderTypes.Button,
          selectable: false,
        }),
      ];
    },
  },
  methods: {
    onAddItemClick: function () {
      this.$emit("add_click", true);
    },
    onDeleteItem: function (item) {
      this.$emit("deleted", item);
    },
    onSelectItem: function (item) {
      this.$emit("selected", item);
    },
    onTextInputBlur: function (event, name, item) {
      this.$emit("changed", {
        name,
        value: event.target.value,
        item,
      });
    },
    getValue: function (item, header = dHeader()) {
      if (header.valueFunc) {
        return header.valueFunc(item);
      } else {
        return item[header.value];
      }
    },
    onCheckboxChange: function (evnet, header, item) {
      const value = event.target.checked ? "1" : "0";
      this.$emit("changed", {
        name: header.value,
        value,
        item,
      });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-dtable {
  .dt-ntable {
    th:nth-child(1),
    td:nth-child(1) {
    }

    td.label_td {
      cursor: pointer;
      font-weight: 600;

      &:hover {
        color: var(--text-secondary);
      }
    }

    td.dtable-field {
      &.first {
        padding-left: 0px;
      }
    }

    th:nth-child(2),
    td:nth-child(2) {
      flex: 1;
    }

    th:last-child,
    td:last-child {
      flex: 0.4;
      max-width: 40px;
    }
  }
}
.box-head {
  padding: 10px;
  border: 1px solid #ccc;
  border-bottom: 0px;
  p {
    margin-bottom: 0px;
  }
  p:nth-child(2) {
    float: right;
    margin-bottom: 0px;
    margin-top: -25px;
  }
}
.items-list {
  border: 1px solid #ccc;
}
// .box
// {
//   border: 1px solid #000;
// }
</style>
